/**
 * Parses the response from the aiflow doc-parser webhook.
 *
 * Handles the aiflow format:
 *   { status, items: [{ extracted_data: { success, extracted_data: {...} } }] }
 *
 * Also handles the legacy N8N format for backward compat:
 *   { success, extractedData: { extracted_data: {...} } }
 *   or [ { success, extractedData: { extracted_data: {...} } } ]
 *
 * @param {object} responseData - The parsed JSON response from the webhook
 * @returns {{ success: boolean, extractedData: object|null, parsedContent: string|null }}
 */
export function parseAiFlowResponse(responseData) {
  // New aiflow format
  const item = responseData?.items?.[0];
  if (item?.extracted_data?.success && item.extracted_data?.extracted_data) {
    return {
      success: true,
      extractedData: item.extracted_data.extracted_data,
      parsedContent: item.parsed_content || null
    };
  }

  // Legacy N8N format (array or object)
  const result = Array.isArray(responseData) && responseData.length > 0
    ? responseData[0]
    : responseData;

  if (result?.success && result?.extractedData?.extracted_data) {
    return {
      success: true,
      extractedData: result.extractedData.extracted_data,
      parsedContent: null
    };
  }

  return { success: false, extractedData: null, parsedContent: null };
}
